'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleSelect = exports.errorOrBlur = exports.invalidDotsMsg = exports.invalidTypeMsg = exports.ensureFileEntity = exports.getOrCreateEntity = exports.createImageEntity = exports.findImage = exports.selectImages = exports.getDotCount = exports.getError = exports.uploadImage = exports.onFileComplete = exports.collectionId = exports.ACCEPT_FILE_TYPE = undefined;

var _split2 = require('lodash/fp/split');

var _split3 = _interopRequireDefault(_split2);

var _size2 = require('lodash/fp/size');

var _size3 = _interopRequireDefault(_size2);

var _pick2 = require('lodash/fp/pick');

var _pick3 = _interopRequireDefault(_pick2);

var _get2 = require('lodash/fp/get');

var _get3 = _interopRequireDefault(_get2);

var _add2 = require('lodash/fp/add');

var _add3 = _interopRequireDefault(_add2);

var _flow2 = require('lodash/flow');

var _flow3 = _interopRequireDefault(_flow2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.isUploaded = isUploaded;
exports.blurSelectorOmitFile = blurSelectorOmitFile;
exports.errorCheck = errorCheck;

var _capeLodash = require('cape-lodash');

var _capeSelect = require('cape-select');

var _reduxField = require('redux-field');

var _reduxGraph = require('redux-graph');

var _capeReduxAuth = require('cape-redux-auth');

var _capeFirebase = require('cape-firebase');

var _module = require('./module');

var _dropZoneUtils = require('./FileUpload/dropZoneUtils');

var _windowFileUtils = require('./FileUpload/windowFileUtils');

var _select = require('./select');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ACCEPT_FILE_TYPE = exports.ACCEPT_FILE_TYPE = 'image/jpeg';
var collectionId = exports.collectionId = 'file';
function isUploaded(entity) {
  return entity.bytesTransferred === entity.contentSize;
}
var onFileComplete = exports.onFileComplete = function onFileComplete(dispatch, entity, prefix) {
  return function (store) {
    var state = store.getState();
    var url = (0, _select.getImgSrc)(entity.fileName)(state);
    // Save the URL to the entity.
    dispatch((0, _capeFirebase.updateEntityFields)(entity, { url: url }));

    // dispatch(saved(prefix, { id, value: url }))
    (0, _windowFileUtils.loadImage)((0, _select.getImgPreviewSrc)(url)(state)).then(function () {
      return dispatch((0, _reduxField.clear)(prefix));
    });
    // console.log('done', getFileUrl(fileName))
  };
};

var uploadImage = function uploadImage(dispatch, entity, file, props) {
  // const { fileName } = entity
  (0, _windowFileUtils.loadImageDataUrl)(file, console.error, function (imageInfo) {
    if (!imageInfo) return undefined;

    var dataUrl = imageInfo.dataUrl,
        sizes = _objectWithoutProperties(imageInfo, ['dataUrl']);

    var entityUpdateFields = _extends({}, (0, _pick3.default)(['id', 'type'], entity), sizes);
    dispatch((0, _capeFirebase.saveEntity)(entityUpdateFields));
    if (dataUrl) dispatch((0, _reduxField.meta)(props.prefix, imageInfo));
    return undefined;
  });
  dispatch((0, _capeFirebase.uploadFile)({ file: file, entity: entity })).then(onFileComplete(dispatch, entity, props.prefix));
  // @TODO Make sure there isn't already this file in the database.

  // Need to update the image form field?
  // return uploadTask
};

// Select previous file selector error.
exports.uploadImage = uploadImage;
var getError = exports.getError = (0, _reduxField.fieldValue)(collectionId, 'error');
// The number of dots in the name.
var getDotCount = exports.getDotCount = (0, _flow3.default)((0, _get3.default)('name'), (0, _split3.default)('.'), _size3.default, (0, _add3.default)(-1));

function blurSelectorOmitFile(_ref, file) {
  var onBlur = _ref.onBlur;

  return onBlur((0, _dropZoneUtils.omitFile)(file));
}

var selectImages = exports.selectImages = (0, _reduxGraph.entityTypeSelector)(_module.IMAGE);
var findImage = exports.findImage = (0, _capeSelect.getSelect)(selectImages, (0, _reduxField.fieldValue)(collectionId, 'value.contentSha1'));

var createImageEntity = exports.createImageEntity = function createImageEntity(state) {
  return (0, _flow3.default)(_dropZoneUtils.omitFile, (0, _capeLodash.setField)('id', (0, _get3.default)('contentSha1')), (0, _capeLodash.setKeyVal)('type', _module.IMAGE), (0, _capeLodash.setKeyVal)('agent', (0, _capeReduxAuth.selectUser)(state)));
};
// Get or create entity.
var getOrCreateEntity = exports.getOrCreateEntity = function getOrCreateEntity(file, state) {
  var entity = (0, _get3.default)(file.contentSha1, selectImages(state));
  return entity || createImageEntity(state)(file);
};

// @return promise of entity.
var ensureFileEntity = exports.ensureFileEntity = function ensureFileEntity(props, file) {
  return function (dispatch, getState) {
    var state = getState();
    var entity = getOrCreateEntity(file, state);
    // Attach entity to parent/subject.
    var subject = props.subject,
        fieldId = props.fieldId,
        single = props.single;

    if (subject && fieldId) {
      dispatch((0, _capeFirebase.saveTriple)({ subject: subject, predicate: fieldId, object: entity, single: single }));
    }
    // bytesTransferred
    if (isUploaded(entity)) {
      return Promise.resolve(dispatch(blurSelectorOmitFile(props, entity)));
    }
    // Save to firebase
    return dispatch((0, _capeFirebase.saveEntity)(entity));
  };
};
var invalidTypeMsg = exports.invalidTypeMsg = function invalidTypeMsg(_ref2) {
  var fileFormat = _ref2.fileFormat;
  return 'Invalid file type. Expected ' + ACCEPT_FILE_TYPE + ', got ' + fileFormat + '.';
};
var invalidDotsMsg = exports.invalidDotsMsg = function invalidDotsMsg(dots) {
  return 'The file name must have exactly 1 dot, found ' + dots + '.';
};

function errorCheck(props, file) {
  var clearError = props.clearError,
      error = props.error,
      onError = props.onError;

  if (!file.isAccepted) {
    return onError(invalidTypeMsg(file));
  }
  var dots = getDotCount(file);
  if (dots !== 1) {
    return onError(invalidDotsMsg(dots));
  }
  if (error) {
    console.log('clearError');
    clearError();
  }
  return false;
}

var errorOrBlur = exports.errorOrBlur = function errorOrBlur(next) {
  return function (props) {
    return function (file) {
      var hasError = errorCheck(props, file);
      if (hasError) return hasError;
      blurSelectorOmitFile(props, file);
      return next(props, file);
    };
  };
};
// FILE UPLOAD
var handleSelect = exports.handleSelect = errorOrBlur(function (props, file) {
  var dispatch = props.dispatch,
      prefix = props.prefix;

  (0, _windowFileUtils.loadSha)(file).then(function (fileWithSha) {
    return dispatch(ensureFileEntity(props, fileWithSha));
  }).then(function (entity) {
    if (!isUploaded(entity)) {
      return uploadImage(dispatch, entity, file.file, props);
    }
    return dispatch((0, _reduxField.clear)(prefix));
  });
});


//////////////////
// WEBPACK FOOTER
// ./~/cape-mixer/lib/image.js
// module id = 692
// module chunks = 0